import React from 'react';
import { Navigate } from 'react-router-dom';

// Login is handled in Landing page
const Login = () => {
  return <Navigate to="/?login" replace />;
};

export default Login;

